module.exports = __webpack_public_path__ + "static/img/about11.bee0cf6.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/about11.png
// module id = fQ0W
// module chunks = 1